/* eslint-disable linebreak-style */
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton, Button, colors } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
// import InputIcon from '@material-ui/icons/Input';
import { getCurrentLocale, setCurrentLocale, t } from '../../../../i18n';
import { isFeatureEnabled } from '../../../../config/featureFlags';
import roFlag from '../../../../assets/flags/ro.svg';
import gbFlag from '../../../../assets/flags/gb.svg';
import bgFlag from '../../../../assets/flags/bg.svg';


const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    background:colors.blueGrey[500]
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1) 
  },
  title:{
    marginLeft: theme.spacing(1)
  },
  localeContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
  localeLabel: {
    fontSize: 11,
    fontWeight: 600,
    marginRight: theme.spacing(1),
    textTransform: 'uppercase'
  },
  localeButton: {
    minWidth: 0,
    padding: '2px 8px',
    marginLeft: theme.spacing(0.5),
    fontSize: 11,
    lineHeight: 1.6,
    color: colors.common.white,
    borderColor: 'rgba(255,255,255,0.4)'
  },
  localeButtonActive: {
    backgroundColor: 'rgba(0,0,0,0.22)',
    borderColor: colors.common.white
  },
  localeFlag: {
    width: 16,
    height: 12,
    borderRadius: 2,
    border: '1px solid rgba(255,255,255,0.35)',
    objectFit: 'cover',
    verticalAlign: 'middle',
    marginRight: theme.spacing(0.5)
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen } = props;
 
  const classes = useStyles();

  const [notifications] = useState([]);
  const [currentLocale, setCurrentLocaleState] = useState(()=> getCurrentLocale());
  const showLocaleControl = isFeatureEnabled('i18nMultilang');

  const handleLocaleChange = (nextLocale)=>{
    if (nextLocale === currentLocale) {
      return;
    }
    const resolvedLocale = setCurrentLocale(nextLocale);
    setCurrentLocaleState(resolvedLocale);
  };

  return (
    <AppBar
    
      className={clsx(classes.root, className)}
    >
      <Toolbar>
        <RouterLink to="/" />
       
        <div className={classes.flexGrow} >
          <h2 className={classes.title}>L<span style={{color:'#cc0000'}}>a</span>rexir <span style={{color:'#cc0000'}}>W</span>ebSt<span style={{color:'#cc0000'}}>o</span>re </h2>
        </div>

        {showLocaleControl && (
          <Hidden smDown>
            <div className={classes.localeContainer}>
              <span className={classes.localeLabel}>{t('common.language')}:</span>
              <Button
                className={clsx(classes.localeButton, currentLocale === 'ro' && classes.localeButtonActive)}
                onClick={()=> handleLocaleChange('ro')}
                size="small"
                variant="outlined"
              >
                <img className={classes.localeFlag} src={roFlag} alt="" aria-hidden="true" />
                {t('common.romanian')}
              </Button>
              <Button
                className={clsx(classes.localeButton, currentLocale === 'en' && classes.localeButtonActive)}
                onClick={()=> handleLocaleChange('en')}
                size="small"
                variant="outlined"
              >
                <img className={classes.localeFlag} src={gbFlag} alt="" aria-hidden="true" />
                {t('common.english')}
              </Button>
              <Button
                className={clsx(classes.localeButton, currentLocale === 'bg' && classes.localeButtonActive)}
                onClick={()=> handleLocaleChange('bg')}
                size="small"
                variant="outlined"
              >
                <img className={classes.localeFlag} src={bgFlag} alt="" aria-hidden="true" />
                {t('common.bulgarian')}
              </Button>
            </div>
          </Hidden>
        )}

        <Hidden mdDown>          
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          {/*<IconButton
            className={classes.signOutButton}
            color="inherit"
          >
            <InputIcon />
          </IconButton>
          */}
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};


export default Topbar;
